import SocialLinks from "./SocialLinks";
import TypingText from "./Typing";
import ProfileCard from "./ProfileCard";
import { MapPin } from "lucide-react";
import { useNavigate } from "react-router";
import { ROUTES } from "../router/appRoutes";
import { personalInfo } from "../constants/aboutMeData"
import "../styles/hero.css";

const Hero = () => {
	const navigate = useNavigate();
	return (
		<section
			id="home"
			className="home_container"
		>
			<div className="image_container">
				<ProfileCard
					name={personalInfo.email}
					title="Software Engineer"
					handle="Junfel"
					status="Online"
					contactText="Contact Me"
					avatarUrl="/images/profile-320.webp"
					miniAvatarUrl="/images/card-avatar.webp"
					showUserInfo={true}
					enableTilt={true}
					enableMobileTilt={false}
					onContactClick={() => navigate(ROUTES.CONTACT)}
					className="hero_image_desktop"
				/>
				<img
					src="/images/profile-600.webp"
					alt="Profile"
					className="hero_image_mobile"
					width={320}
					height={320}
				/>
			</div>

			<div className="hero-content">
				<div className="text_content">
					<p>Hi, I'm</p>
					<h1 className="hero_title">Junfel Velasco</h1>
					<h2 className="designation_info">
						{/* <TypingText /> */}
						Web Developer
					</h2>
					<p className="my_address">
						<MapPin /> &nbsp; Cebu, Philippines
					</p>
					<br />
					<SocialLinks />
					{/* <p className="btn-primary">Show more ...</p> */}
				</div>
			</div>
		</section>
	);
};

export default Hero;
